import type { FC, SVGProps } from 'react';

import CalendarIconSvg from './calendar.svg';

/** Иконка календаря. */
const CalendarIcon: FC<SVGProps<SVGSVGElement>> = CalendarIconSvg;

export default CalendarIcon;
